import ToolbarLinks from './ToolbarLinks'

ToolbarLinks.install = function install (Vue) {
  Vue.component(ToolbarLinks.name, ToolbarLinks)
}

export default ToolbarLinks



// WEBPACK FOOTER //
// ./src/components/toolbar-links/index.js